import React, { useState, useEffect, useRef } from "react";

interface FileData {
  pngFiles: Blob[];
}

interface ResizableImageProps {
  fileData: FileData;
  sliderValue: number;
}

const ResizableImage: React.FC<ResizableImageProps> = ({
  fileData,
  sliderValue,
}) => {
  const [size, setSize] = useState<number>(window.innerWidth * 0.7);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      setSize((prevSize) => prevSize - e.deltaY * 0.1);
    };

    window.addEventListener("wheel", handleWheel);

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <div
      className="fixed inset-0 flex justify-center items-center pointer-events-none"
      style={{ paddingTop: "80px", zIndex: -1, position: "relative" }}
    >
      <div className="border pointer-events-auto">
        <img
          ref={imgRef}
          src={URL.createObjectURL(fileData.pngFiles[sliderValue])}
          alt="2D Image"
          style={{
            maxWidth: `${size}px`,
            maxHeight: `${size}px`,
            objectFit: "contain",
            zIndex: -1,
          }}
        />
      </div>
    </div>
  );
};

export default ResizableImage;
